/**
 * Session timeout utility for handling token expiration
 * Stores current page URL for redirect after re-login when 401 occurs
 */

const REDIRECT_URL_KEY = 'redirectUrlAfterLogin';

/**
 * Store the current page URL for redirect after login
 */
export const storeRedirectUrl = () => {
    const currentPath = window.location.pathname + window.location.search;
    if (currentPath !== '/login') {
        sessionStorage.setItem(REDIRECT_URL_KEY, currentPath);
        console.log('Stored redirect URL:', currentPath);
    }
};

/**
 * Get the stored redirect URL and clear it
 */
export const getAndClearRedirectUrl = () => {
    const redirectUrl = sessionStorage.getItem(REDIRECT_URL_KEY);
    if (redirectUrl) {
        sessionStorage.removeItem(REDIRECT_URL_KEY);
        console.log('Retrieved and cleared redirect URL:', redirectUrl);
        return redirectUrl;
    }
    return null;
};

/**
 * Clear the stored redirect URL
 */
export const clearRedirectUrl = () => {
    sessionStorage.removeItem(REDIRECT_URL_KEY);
    console.log('Cleared redirect URL');
};
